import * as React from 'react';
import { observer } from 'mobx-react';
import { PageSuccessViewModel } from './page-success-view-model';
import * as styles from "./page-success.less";

import { ResetPageReason } from '../../payer-onboarding-generated';
import { PayerOnboardingUserAction } from '../../payer-onboarding-user-actions';
import { ErrorMessage } from '../../components/error-message/error-message';

import { Button, ButtonStyle } from '../../../WebGiving/primitives/button/button';
import { FadeTransition, fadeTransitionDuration } from '../../../WebGiving/components/fade-transition';
import { getPageClasses } from '../../../WebGiving/pages/helpers/get-page-classes';
import { PanelHeading } from '../../../WebGiving/components/panel-heading';
import { PanelFooter } from '../../../WebGiving/components/panel-footer';
import { pageFooter } from '../../../WebGiving/main/webgiving-main.less';
import { FocusOnMount } from '../../../WebGiving/components/focus-on-mount-hoc';
import { AppStoreCallToAction } from '../../../WebGiving/components/app-store-call-to-action/app-store-call-to-action';
import { HeartAnimation } from '../../../WebGiving/components/heart-animation/heart-animation';

@observer
export class PageSuccess extends React.Component<{
	vm: PageSuccessViewModel,
	raiseAction: (action: PayerOnboardingUserAction) => void,
	transitionState: string,
}> {
	render() {
		const { vm, transitionState } = this.props;
		const {
			firstName,
			error,
			isLoading,
			pageShouldBeVisible,
			isBlocked,
			paymentLabel,
			getAppUrl,
			merchantAppName,
			hasCustomApp,
			hasWelcomeSmsBeenSent,
			appContentCard,
		} = vm;

		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Success page` : null}>
				<PanelHeading vm={vm}>
					<FadeTransition in={elementsShouldEnter}>
						<div>
							<ErrorMessage error={error} onResetPage={this.handleResetPage} />
							<HeartAnimation />

							<h1>Thanks, {firstName}!</h1>
							<p className="lead">
								You have successfully created an account. You can now manage your payment methods, track your {paymentLabel.NounLowerCase} history
								and schedule recurring {paymentLabel.NounPluralLowerCase} through your account.
							</p>
							<>
								<FocusOnMount delay={fadeTransitionDuration}>
									<Button
										className="button"
										buttonStyle={ButtonStyle.Ghost}
										acceptanceTestTargetId="GiveNow"
										onClick={this.handleGiveNow}
										isLoading={isLoading}
										isBlocked={isBlocked}>
										{paymentLabel.VerbSentenceCase} Now
								</Button>
								</FocusOnMount>
								<div className={styles.secondaryCta}>
									<a
										className="brand-link"
										href="#"
										data-pp-at-target="Login"
										onClick={this.handleLogin}>
										Explore my account
									</a>
								</div>
							</>
						</div>
					</FadeTransition>
				</PanelHeading>
				{hasCustomApp &&
					<PanelFooter className={pageFooter}>
						<AppStoreCallToAction getAppUrl={getAppUrl}
							mobileAppName={merchantAppName}
							paymentLabel={paymentLabel}
							hasCustomApp={hasCustomApp}
							hasWelcomeSmsBeenSent={hasWelcomeSmsBeenSent}
							appContentCard={appContentCard}
						/>
					</PanelFooter>
				}
			</div>
		);
	}

	private handleResetPage = (reason?: ResetPageReason) => {
		this.props.raiseAction(new PayerOnboardingUserAction.ResetPageBecauseOfError(reason));
	}

	private handleGiveNow = () => {
		this.props.raiseAction(new PayerOnboardingUserAction.GiveNow());
	}

	private handleLogin = () => {
		this.props.raiseAction(new PayerOnboardingUserAction.Login());
	}
}
